var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPenNib(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M15.0008 7.0004L7.54122 9.79777C7.3769 9.85937 7.2317 9.96314 7.12018 10.0986C7.00867 10.2341 6.93478 10.3966 6.90593 10.5697L4.00081 28.0004L21.4315 25.0953C21.6046 25.0664 21.7671 24.9925 21.9026 24.881C22.0381 24.7695 22.1418 24.6243 22.2034 24.46L25.0008 17.0004L15.0008 7.0004ZM14.5001 20C14.0056 20 13.5223 19.8534 13.1112 19.5787C12.7 19.3039 12.3796 18.9135 12.1904 18.4567C12.0012 17.9999 11.9517 17.4972 12.0481 17.0123C12.1446 16.5273 12.3827 16.0818 12.7323 15.7322C13.0819 15.3826 13.5274 15.1445 14.0124 15.048C14.4973 14.9516 15 15.0011 15.4568 15.1903C15.9136 15.3795 16.3041 15.6999 16.5788 16.1111C16.8535 16.5222 17.0001 17.0055 17.0001 17.5C17.0001 17.8283 16.9354 18.1534 16.8098 18.4567C16.6841 18.76 16.5 19.0356 16.2679 19.2677C16.0357 19.4999 15.7601 19.684 15.4568 19.8097C15.1535 19.9353 14.8284 20 14.5001 20Z",
    fill: "#FF6636"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 20C15.8807 20 17 18.8807 17 17.5C17 16.1193 15.8807 15 14.5 15C13.1193 15 12 16.1193 12 17.5C12 18.8807 13.1193 20 14.5 20Z",
    stroke: "#FF6636",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.00065 28.0004L12.7322 19.2677",
    stroke: "#FF6636",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.00065 28.0005L21.4314 25.0953C21.6045 25.0665 21.7669 24.9926 21.9024 24.8811C22.0379 24.7696 22.1417 24.6244 22.2033 24.4601L25.0007 17.0004L15.0007 7.00044L7.54104 9.7978C7.37673 9.85942 7.23153 9.96319 7.12002 10.0987C7.00851 10.2342 6.93462 10.3966 6.90577 10.5697L4.00065 28.0005Z",
    stroke: "#FF6636",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0007 17.0004L28.2935 13.7075C28.3864 13.6147 28.4601 13.5044 28.5103 13.3831C28.5606 13.2618 28.5864 13.1317 28.5864 13.0004C28.5864 12.8691 28.5606 12.7391 28.5103 12.6177C28.4601 12.4964 28.3864 12.3862 28.2935 12.2933L19.7078 3.70752C19.5202 3.51998 19.2659 3.41463 19.0007 3.41463C18.7354 3.41463 18.4811 3.51998 18.2935 3.70752L15.0007 7.00041",
    stroke: "#FF6636",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenNib);
export default __webpack_public_path__ + "static/media/PenNib.35d53d9c2fdd66645a7609243d8fae86.svg";
export { ForwardRef as ReactComponent };